<template>
    <div class="page-listings">
        <section class="py-5 banner-bg bs-shadow mobile-top">
      <div class="container">
        <div style="display: flex;">
        <h1 class="text-white mb0 lh1">{{ currentYear }} Onsite Product / Application School Schedule</h1>
    </div>
        <hr class="header-divide" />
        <div class="search-btns">
          <div class="left-side" style="margin-right: 20px">
            <div>
            
              <h5 className="text-white mb-[10px]">Product School (In Person) includes:</h5>
              <div class="row">
                <div class="col-xs-12 col-md-6 col-12">
                    <ul className="text-white mb0">
          <li>Standard Mobile</li>
          <li>Wheelhouse</li>
          <li>Powered Mobile</li>
          <li>ActivRAC</li>
          <li>RaptorRAC</li>
          <li>XTend, High Bay</li>
          <li>Shelving - Cantilever, FrameWRX, EZ Rail, WRX Wheels</li>
          <li>Museum Cabinets & Cantilever Racks</li>
        </ul>
                </div>
                <div class="col-xs-12 col-md-6 col-12">
                    <ul className="text-white">
          <li>Art Racks</li>
          <li>Lockers – FreeStyle, Rival, Evidence,
          ControLoc, Tactical Readiness, Gun Boxes</li>
          <li>Day Use Lockers</li>
          <li>Weapon Racks</li>
          <li>Deployables – Tricon, Rapid Readiness
          Box, Parachute Containers</li>
          <li>Grow Products</li>
        </ul>
                </div>
              </div>

              <!--
              <div className="grid-container">
              <ul className="text-white">
          <li>Standard Mobile</li>
          <li>Wheelhouse</li>
          <li>Powered Mobile</li>
          <li>ActivRAC</li>
          <li>RaptorRAC</li>
          <li>XTend, High Bay</li>
          <li>Shelving - Cantilever, FrameWRX, EZ Rail, WRX Wheels</li>
          <li>Museum Cabinets & Cantilever Racks</li>
          <li>Art Racks</li>
          <li>Lockers – FreeStyle, Rival, Evidence,
          ControLoc, Tactical Readiness, Gun Boxes</li>
          <li>Day Use Lockers</li>
          <li>Weapon Racks</li>
          <li>Deployables – Tricon, Rapid Readiness
          Box, Parachute Containers</li>
          <li>Grow Products</li>
        </ul>
    </div>
-->
            </div>
          </div>
        </div>
      </div>
    </section>

      <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
        
        <div data-v-5a90ec03 class="container">
     
          
      
  
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            :duration="500"
            mode="out-in"
            appear
          >
          <div>
            <div class="step1" key="step1">
              <div class="bg-card"> 
            
                <h3 className="text-base/10 font-semibold text-gray-900">We are excited to announce the {{ currentYear }} onsite Spacesaver Product / Application Schools!</h3>
   <hr/>
     <p className="mb-[20px]"> These schools are open to all Area Contractors, Distributors, and their team members. We urge you to take advantage of these opportunities to have your internal and external salespeople, A&D and demand generation teams, and Configura personnel learn about Spacesaver products, applications, and markets. We do recommend attendees have at least 90 days in their position, or industry experience prior to attending.</p>
     <p>These schools include extensive product, sales, and market insights, application hands on training, as well as plant and office tours. Attendees will enjoy lunches and two offsite dinners with a variety of Spacesaver teammates.
        </p>
        <p>Please review the entire memo for hotel, transportation, meals, and sign-up information.</p>

                <hr />

              
            
                    <h3 className="text-base/10 font-semibold text-gray-900">Training Location</h3>
                <p className="mb-[20px]">The training will take place at the Spacesaver corporate office. There will be no course fee to attend the training. There will not be virtual options during this training.</p>
                <p class="mb5"><b>Spacesaver Corporation</b></p>
                <p class="mb5"><b>1450 Janesville Ave</b></p>
                <p class="mb5"><b>Fort Atkinson, WI 53538</b></p>
                <p class="mb5"><b>(920) 563-6362</b></p>
  
        
             
                 
  
                
            
          
           
              
               

            

                <hr/>

                <h3 className="text-base/10 font-semibold text-gray-900">Hotel Accommodations</h3>
                <p class="mb5"><b>Country Inn & Suites</b></p>
                <p class="mb5"><b>1650 Doris Drive</b></p>
                <p class="mb5"><b>Fort Atkinson, WI 53538</b></p>
                <p class="mb20"><b>920-542-1600</b></p>
                
<p>Hotel costs are the responsibility of the attendee. <b>We (Spacesaver) will make all hotel reservations, based on registration information, under our corporate rate of $91.00 per night plus tax.</b> Attendees must present a credit card at time of check in. Please be sure to indicate on your registration form the dates of arrival and departure so we can reserve the rooms appropriately.</p>

<hr/>
<h3 className="text-base/10 font-semibold text-gray-900">Meals</h3>
<p>There is a free Continental Breakfast provided at the Country Inn & Suites daily beginning at 6:00 am if you choose to have breakfast before arriving to school each day. Snacks will be provided in the morning before lunch and after lunch on all days. Lunches will be provided during school. Spacesaver will host dinners Tuesday and Wednesday evenings, all other dinners will be the responsibility of the attendee.</p>
<hr/>

<h3 className="text-base/10 font-semibold text-gray-900">Transportation</h3>
<p>Transportation is the responsibility of the attendee. You are responsible for arranging for your transportation to and from Fort Atkinson, Wisconsin as well as to and from the hotel; we will not be providing transportation and the hotel does not have a shuttle. Please allow adequate travel time from the time the course finishes before your return flight.</p>
<ul>
    <li>The Milwaukee and Madison airports are closest to Fort Atkinson. Chicago O’Hare and Midway (in Chicago) are options for you that are fairly close to Fort Atkinson as well. All these airports have rental cars available. <b>Do NOT rely on Uber or Lyft, these car services are not locally available.</b></li>
</ul>


<hr/>

<h3 className="text-base/10 font-semibold text-gray-900">Miscellaneous</h3>
<ul>
    <li>Dress Code: Business Casual. Closed-toe shoes are required for the Plant tour. We suggest you bring a sweater or jacket as the training room temperature can vary.</li>
    <li>Cell phones and laptops should not be in use during class. There will be breaks provided throughout the day for attendees to address business needs as necessary.</li>
</ul>

<hr/>

<h3 className="text-base/10 font-semibold text-gray-900">Cancellation Policy</h3>

<p>
Spacesaver will make every effort to conduct this training as scheduled, but, since unforeseen circumstances can arise, Spacesaver retains the right to cancel training any time prior to 30 days before training. Spacesaver will not reimburse for any expenses incurred by the attendee for booking travel more than 30 days in advance.</p>
<p style="margin-bottom: 50px;">To register for any of these schools, or if you have questions, please contact <b>Brenna Schilt</b> at <a href="tel:+19205630558" style="color: #429da8;">(920) 563-0558</a> or via e-mail at <a href="mailto:bschilt@spacesaver.com" style="color: #429da8;">bschilt@spacesaver.com</a>. Completion and submission of the registration form required to secure spot. Please register soon as availability is limited to a maximum of 18 attendees.</p>
              

<a href="https://spacesaver.widen.net/view/pdf/uxhqtzjytz/In-Person-Product-School-Memo.pdf?t.download=true&u=sphzbh" target="_blank" class="btn-primary" style="padding: 10px 20px; margin-right: 20px; text-decoration: none;">Download Memo</a>

<a href="https://spacesaver.widen.net/view/pdf/yrw9laiegm/Product-School-Overview-Agenda.pdf?t.download=true&u=sphzbh" target="_blank" class="btn-primary" style="padding: 10px 20px; text-decoration: none;">Download Agenda</a>

                
 


                   
                <div class="row">
                  <div class="col-xs-12 col-md-6 col-12">
            
                   
  
        
             
                 
  
                
            
          
           
                  </div>
                  <div class="col-xs-12 col-md-6 col-12">
             
                    
                  </div>
                </div>

              </div>
            </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { AtomSpinner } from "epic-spinners";
  // import Avatar from "vue-avatar";
  // import Datepicker from "vuejs-datepicker";
  import VueDatePicker from '@vuepic/vue-datepicker';
  import Multiselect from "vue-multiselect";
  import { HollowDotsSpinner } from "epic-spinners";
  import Banner1 from "../components/Banners/banner1.vue";
  import vSelect from "vue-select";
  import { jwtDecode } from "jwt-decode";
  import "vue-select/dist/vue-select.css";
  import "vue-multiselect/dist/vue-multiselect.min.css";
  // import "animate.css";
  
  const auth = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    },
  };
  
  export default {
    name: "ProductSchoolInfo",
    components: {
      AtomSpinner,
      // Avatar,
      // Datepicker,
      VueDatePicker,
      Multiselect,
      HollowDotsSpinner,
      Banner1,
      vSelect
    },
    data() {
      return {
        ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
        server: import.meta.env.VITE_APP_SERVER_URL,
        backend: import.meta.env.VUE_APP_SERVER_URL,
     
             
      };
    },
    methods: {

  
      firstLoad: function () {

        this.loading = true;
        this.$store.commit("setActivePage", "order-manage");
        //return axios.get(this.endPointCompute, auth).then((response) => {
        /*
        return axios
          .get(`${this.ordermanageapi}/aclist?all=yes&active=true`, auth)
          .then((response, acs) => {
            //console.log(response);
            this.acs = response.data;
            this.loading = false;
          })
  
          .then(() => {
            return axios
  
              .get(`${this.ordermanageapi}/salespeople`, auth)
              .then((response, salespeople) => {
                //console.log(response);
                this.salespeople = response.data.salesPeople;
                this.loading = false;
              });
          })
          .then(() => {
            return axios
  
              .get(`${this.ordermanageapi}/options?type=ptypes`, auth)
              .then((response, productTypes) => {
                //console.log(response);
                this.productTypes = response.data.productTypes;
                this.loading = false;
              });
          })
          .then(() => {
            return axios
  
              .get(`${this.server}/api/v1/ac-territories`, auth)
              .then((response) => {
                if (response.status === 401) {
                  console.log("not allowed");
                } else {
                  //console.log(response);
                  this.acList = response.data.aCDistributors;
                }
              });
          });
          */
      },

      

  

  

  
      setPage: function (idx) {
        document.activeElement.blur();
        if (idx <= 0 || idx > this.totalPage) {
          return;
        }
        document
          .getElementById("ScrollTarget")
          .scrollIntoView({ behavior: "smooth" });
        this.step = idx;
      },
     

    },
    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
      activeNav() {
        return this.$store.state.activePage;
      },
      colorGetter() {
        return this.$store.state.colors;
      },
       checkFirst: function(){
         if(this.contactName.length){
           let fullName = this.contactName.split(' ');
           return fullName[0]
         } else {
           return '';
         }
      },
  
      checkLast: function(){
         if(this.contactName.length){
           let fullName = this.contactName.split(' ');
           return fullName[1]
         } else {
           return '';
         }
      },





    },
    created() {
      this.$store.commit("showNavigation");
      // console.log(this.$route.path);
    },
    mounted() {
      this.firstLoad();
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #pickDate1 input {
    border: 0 !important;
    outline: none !important;
  }
  
  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #00b4b4;
    border-color: #00b4b4;
  }

  .btn-primary:focus{
    color: #fff;
    background-color: #429da8;
    border-color: #429da8;
  }
  
  .leadTime {
    background-color: #fff;
    line-height: 44px;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  .top-wrap {
    display: flex;
    align-items: flex-start;
  }
  .leadTime-bottom {
    align-items: flex-end;
  }
  .leadTime-header {
    background: #fff;
    color: #575757;
    display: flex !important;
  }
  .small-lh {
    line-height: 1.4em;
  }
  
  .listing {
    overflow: none;
  }
  
  .listing {
    background-color: #fff;
    line-height: 1;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  
  .table-responsive {
    display: table;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }
  .table-bordered td,
  .table-bordered th {
    border: 1px solid #e8e8e8 !important;
  }
  .badge-success {
    color: #fff;
    background-color: #4d5967;
    background-color: #1eb5b6;
  }
  .table-striped a {
    color: #00b4b4;
  }
  .table-striped td,
  .table-striped th {
    padding: 5px;
    font-weight: 300 !important;
  }
  .listing {
    border-radius: 4px;
  }
  table td {
    line-height: 1;
  }
  .table-striped th {
    background: #00b4b4;
    background: #4d5967;
    color: #fff;
  }
  .table-striped {
    min-width: 100%;
    overflow: scroll;
  }
  .search-btns {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .search-btns button {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    max-height: 40px;
  }
  .search-btns .clear {
    margin-left: auto;
  }
  .search-btns .search {
    margin-left: 5px;
  }
  .search-btns button span {
    font-size: 20px;
    width: 20px;
    height: 20px;
    color: #fff;
  }
  .search-btns button:hover {
    background: #586575;
  }
  .search-btns button:active {
    background: #586575;
  }
  .search-btns button:disabled {
    opacity: 0.6;
    cursor: unset !important;
  }
  .search-btns button:disabled:hover {
    background: #4d5967;
  }
  .search-btns button:disabled:active {
    background: #4d5967;
  }
  
  @media all and (min-width: 768px) {
    .dates {
      display: flex;
      color: #757575 !important;
    }
  }
  .top-search {
    color: #757575;
  }
  select.form-control:not([size]):not([multiple]) {
    height: auto !important;
    padding: 10px !important;
    color: #757575;
  }
  .all-contractors {
    color: #757575 !important;
  }
  .header-divide {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
  .table-striped td:last-of-type {
    text-align: right;
  }
  .table-striped th:last-of-type {
    text-align: right;
  }
  .table-bordered td:first-of-type {
    border-right: none !important;
  }
  .table-bordered th:first-of-type {
    border-right: none !important;
  }
  .table-bordered td:last-of-type {
    border-left: none !important;
  }
  .table-bordered th:last-of-type {
    border-left: none !important;
  }
  .m50 {
    margin: 50px 0;
  }
  .nav-btns {
    display: flex;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease-out;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .slide-leave-active,
  .slide-enter-active {
    transition: 1s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }
  .listing-header {
    background: #fff;
    color: #575757;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .loader {
    margin: 0 auto 20px;
    width: 100%;
    height: 25px;
    border-radius: 14px;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #999;
    background: #ccc;
    overflow: hidden;
    position: relative;
  }
  
  .progress-bar {
    height: inherit;
    width: 0%;
    border-radius: inherit;
    position: relative;
    overflow: hidden;
  }
  
  .progress-stripes {
    width: inherit;
    height: inherit;
    font-size: 180px;
    font-weight: bold;
    margin-top: -50px;
    letter-spacing: -14px;
  }
  
  .percentage {
    position: absolute;
    top: 0;
    right: 5px;
    font-weight: bold;
    font-size: 16px;
  }
  /* PURPLE */
  .teal .progress-bar {
    background: #00bcbc;
  }
  .teal .progress-stripes {
    color: #00b4b4;
  }
  .teal .percentage {
    color: #eee;
  }
  .first-step {
    width: 20%;
  }
  .second-step {
    width: 60%;
  }
  .third-step {
    width: 90%;
  }
  .fourth-step {
    width: 100%;
  }
  .fifth-step {
    width: 90%;
  }
  .teal {
    color: #00b4b4;
  }
  .lookup-wrapper {
    text-align: center;
  }
  .lookup-svg {
    width: 300px;
    height: auto;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-right: auto;
    margin: 0 auto;
  }
  .show-all-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: rgb(124, 124, 129);
  
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 20px;
  }
  .show-all-btn:hover {
    background: #4d5967;
  }
  .custom-control-label:before {
    background-color: #dedede;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #00b4b4 !important;
  }
  input:focus {
    border-color: #00BCBC;
  }
  textarea:focus {
    border-color: #00BCBC;
  }
  </style>
  <style>
  .style-chooser .vs__selected{
        background-color: #00BCBC!important;
        color: #fff!important;
  }
  .style-chooser .vs__dropdown-option--highlight{
      background-color: #00BCBC!important;
      color: #fff!important;
  }
  .style-chooser .vs__selected-options{
    padding: 10px;
  }
  .style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
  }
  .style-chooser .vs__deselect{
    fill: #fff;
  }
  .style-chooser .vs__selected{
    border: none;
    font-weight: 300;
    padding: 2px 10px;
  }
  .style-chooser .vs__dropdown-toggle{
    padding: 0;
  }
  .style-chooser .vs__search{
    margin: 0;
    padding: 0;
  }
  
  element.style {
  }
  .form-control {
      display: block;
      width: 100%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  textarea {
      overflow: auto;
      resize: vertical;
  }
  button, input, optgroup, select, textarea {
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
  }
  *, ::after, ::before {
      box-sizing: border-box;
  }
  user agent stylesheet
  textarea {
      box-sizing: border-box;
  }
  .success-header{
    background: #00b4b4;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .success-header img{
      max-width: 200px;
      
  }
  .failure-header{
    background: #5a6877;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .failure-header img{
      width: 200px;
      
  }
  .success-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body a{
    color: #00BCBC;
  }
  .failure-body p {
    margin-bottom: 5px;
  }
  .orange{
    color:#f16232
  }
  .header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.banner-bg {
background-color: #00BCBC;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cuse href='%23a' y='-1400'/%3E%3Cuse href='%23a' y='-1300'/%3E%3Cuse href='%23a' y='-1200'/%3E%3Cuse href='%23a' y='-1100'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-900'/%3E%3Cuse href='%23a' y='-800'/%3E%3Cuse href='%23a' y='-700'/%3E%3Cuse href='%23a' y='-600'/%3E%3Cuse href='%23a' y='-500'/%3E%3Cuse href='%23a' y='-400'/%3E%3Cuse href='%23a' y='-300'/%3E%3Cuse href='%23a' y='-200'/%3E%3Cuse href='%23a' y='-100'/%3E%3Cg stroke='%2300B4B4' stroke-width='0' id='a'%3E%3Cpath fill='%2300B4B4' d='M0 0l2100 40l-2100 40z'/%3E%3C/g%3E%3Cuse href='%23a' y='100'/%3E%3Cuse href='%23a' y='200'/%3E%3Cuse href='%23a' y='300'/%3E%3Cuse href='%23a' y='400'/%3E%3Cuse href='%23a' y='500'/%3E%3Cuse href='%23a' y='600'/%3E%3Cuse href='%23a' y='700'/%3E%3Cuse href='%23a' y='800'/%3E%3Cuse href='%23a' y='900'/%3E%3Cuse href='%23a' y='1000'/%3E%3Cuse href='%23a' y='1100'/%3E%3Cuse href='%23a' y='1200'/%3E%3Cuse href='%23a' y='1300'/%3E%3Cuse href='%23a' y='1400'/%3E%3Cuse href='%23a' y='1500'/%3E%3Cuse href='%23a' y='1600'/%3E%3Cuse href='%23a' y='1700'/%3E%3Cuse href='%23a' y='1800'/%3E%3Cuse href='%23a' y='1900'/%3E%3Cuse href='%23a' y='2000'/%3E%3Cuse href='%23a' y='2100'/%3E%3Cuse href='%23a' y='2200'/%3E%3Cuse href='%23a' y='2300'/%3E%3Cuse href='%23a' y='2400'/%3E%3Cuse href='%23a' y='2500'/%3E%3Cuse href='%23a' y='2600'/%3E%3Cuse href='%23a' y='2700'/%3E%3Cuse href='%23a' y='2800'/%3E%3C/g%3E%3Cuse href='%23b' x='-1' transform='scale(-1 1)'/%3E%3C/g%3E%3Cuse href='%23c' x='' transform='rotate(90 0 0)' style='transform-origin:center'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
background-attachment: fixed;
background-size: cover;
}

.myTest .custom-control-input {
  margin-top: 0; /* Remove default offset */
}

/* Ensure label text aligns properly */
.myTest .custom-control-label {
  display: flex;
  align-items: center; /* Center the <small> text vertically within the label */
}

/* Adjust <small> styling if needed */
.myTest .form-text {
  margin-top: 0; /* Preserve original inline style */
  line-height: 1.5; /* Improve text alignment */
}
.bg-card{
    border-radius: 4px;
    background-color: #fff;
    line-height: 1.5;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
    padding-bottom: 35px;

}
.bg-card p{

    font-size: 18px;
    font-weight: 300;
}
  </style>
  